import { Box, Fade, Grid, Grow, IconButton, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { clearScore, getParticipants, getScoring } from './ParticipantsRequests'
import ReplayIcon from '@mui/icons-material/Replay';
import { blue, green, orange, red, yellow } from '@mui/material/colors';
import Stat from '../assets/stat.jpg';
import StarIcon from '@mui/icons-material/Star';
import GroupIcon from '@mui/icons-material/Group';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import KeyIcon from '@mui/icons-material/Key';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PersonIcon from '@mui/icons-material/Person';
import Swal from 'sweetalert2';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    //   border: '2px solid #000',
    borderRadius:5,
    boxShadow: 24,
    p: 4,
};
export const Participants = () => {
    const [list,setList] = useState([])
    const [participants,setParticipants] = useState([])
    useEffect(()=>{
        _init();
        _getScoring();
    },[])
    const _init = async () =>{
        const res = await getParticipants()
        setParticipants(res.data.data)
        console.log(res)
    }
    const _getScoring = async () => {
        const res = await getScoring()
        setList(res.data.data)
        console.log(res.data)
    }
    const handleReload = () => {
        _getScoring();
    }
    const handleViewParticipants = () =>{
        console.log(participants)
    }
    const [openModal,setOpenModal] = useState(false);
    const handleOpenModal = () => setOpenModal(true)
    const handleCloseModal = () => setOpenModal(false)
    const handleClearScore = async () => {
        try{
            Swal.fire({
                icon:'question',
                title:'Confirm Clearing Score ?',
                text:'Action cannot be reverted',
                showCancelButton:true,
                confirmButtonText:'Yes, Confirm',
                cancelButtonText:'No, Cancel'
            }).then(async res=>{
                if(res.isConfirmed){
                    Swal.fire({
                        icon:'info',
                        title:'Clearing Score',
                        text:'Please wait...'
                    })
                    Swal.showLoading();
                    const res = await clearScore();
                    if(res.data.status === 200){
                        setList(res.data.data)
                        Swal.fire({
                            icon:'success',
                            title:res.data.message,
                            showConfirmButton:false,
                            timer:1500
                        })
                    }else{
                        Swal.fire({
                            icon:'error',
                            title:res.data.message
                        })
                    }
                }
            })
            
        }catch(err){
            Swal.fire({
                icon:'error',
                title:err
            })
        }
    }
    return(
        <Box>
        <Grow in>
            <img src={Stat} height='100%' width='100%' style={{position:'absolute',zIndex:-2,opacity:'.5'}}/>
        </Grow>
        <Box sx={{p:5}}>
            <Box sx={{display:'flex',justifyContent:'flex-start',width:'100%'}}>
                <Typography variant='h3' sx={{color:orange[800]}}>Score Board</Typography>
            </Box>
            
            <Tooltip title='Reload Score'>
                <IconButton sx={{float:'right'}} color='primary' onClick={handleReload}><ReplayIcon/></IconButton>
            </Tooltip>
            <Tooltip title='View Participant'>
            <IconButton sx={{float:'right'}} color='info' onClick={handleOpenModal}><GroupIcon/></IconButton>
            </Tooltip>
            <Tooltip title='Clear Score'>
                <IconButton sx={{float:'right'}} color='error' onClick={handleClearScore}><DeleteForeverIcon/></IconButton>
            </Tooltip>
            <Grow in>
                <Paper>
                <Grid container>
                    <Grid item xs={12}>
                        <TableContainer sx={{maxHeight:'60dvh'}}>
                            <Table>
                                <TableHead sx={{position:'sticky',top:0}}>
                                    <TableRow sx={{background:blue[800]}}>
                                        <TableCell rowSpan={2} align='center' sx={{fontSize:'2rem',color:'#fff',fontWeight:'bold'}}>
                                            <span>RANK <br/> <StarIcon sx={{color:yellow[800]}}/></span>
                                        </TableCell>
                                        <TableCell align='center' rowSpan={2} sx={{fontSize:'2rem',color:'#fff',fontWeight:'bold'}}>
                                            Name
                                        </TableCell>
                                        <TableCell align='center' rowSpan={2} sx={{fontSize:'2rem',color:'#fff',fontWeight:'bold'}}>
                                            Office
                                        </TableCell>
                                        <TableCell colSpan={3} sx={{fontSize:'2rem',color:'#fff',fontWeight:'bold'}} align='center'>
                                            Levels of Difficulty
                                        </TableCell>
                                        <TableCell rowSpan={2} sx={{fontSize:'2rem',color:'#fff',fontWeight:'bold'}} align='center'>
                                                Total Score
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{background:'#fff'}}>
                                        <TableCell sx={{fontSize:'1.5rem',fontWeight:'bold',color:green[500]}} align='center'>
                                            Easy
                                        </TableCell>
                                        <TableCell sx={{fontSize:'1.5rem',fontWeight:'bold',color:orange[500]}} align='center'>
                                            Average
                                        </TableCell>
                                        <TableCell sx={{fontSize:'1.5rem',fontWeight:'bold',color:red[500]}} align='center'>
                                            Difficult
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        list.length>0
                                        ?
                                            list.map((item,key)=>{
                                                return (
                                                    <TableRow key={key} hover>
                                                        <TableCell align='center' sx={{fontSize:'1.5rem'}}>
                                                            {item.rank}
                                                        </TableCell>
                                                        <TableCell align='center' sx={{fontSize:'1.5rem'}}>
                                                            {item.name}
                                                        </TableCell>
                                                        <TableCell align='center' sx={{fontSize:'1.5rem'}}>
                                                            {item.office}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize:'1.5rem'}} align='center'>
                                                            {item.easy}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize:'1.5rem'}} align='center'>
                                                            {item.intermediate}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize:'1.5rem'}} align='center'>
                                                            {item.hard}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize:'1.5rem',background:orange[50]}} align='center'>
                                                            {item.score}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        :
                                        <TableRow>
                                            <TableCell align='center' colSpan={7}>
                                                No data as of the moment
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                </Paper>
            </Grow>
        </Box>
        <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                List of Participants
            </Typography>
            <Grow in>
            <List>
                {
                    participants.map((item)=>{
                        return (
                            <ListItem disablePadding key={item.participant_id}>
                                <ListItemButton>
                                <ListItemIcon>
                                    <PersonIcon />
                                </ListItemIcon>
                                <ListItemText primary={item.name} secondary={<Box sx={{display:'flex',alignItems:'center',gap:1}}><KeyIcon/> {item.code}</Box>}/>
                                </ListItemButton>
                            </ListItem>
                        )
                    })
                }
                </List>
            </Grow>
            </Box>
        </Modal>
        </Box>

    )
}